<template>
    <div
            class="v-sidebar-menu"
            :class="[!isCollapsed ? 'vsm-default' : 'vsm-collapsed', theme, rtl ? 'rtl' : '']"
            :style="{'width': sidebarWidth}"
            @mouseleave="mouseLeave"
    >
        <div class="vsm-list">

            <template v-for="(item, index) in menu">
                <template v-if="item.header">
                    <template>
                        <div
                                :key="index"
                                class="vsm-header"
                                :class="item.class"
                                v-bind="item.attributes"
                        >   <img style="max-height: 70px;padding: 15px;" src="/img/logo-ogg.png">
                            <br/>
                            Olá {{ store.state.data.username }} <br/>
                            <span style="color: #555555">Último acesso <br/> {{ store.state.data.last_access }}</span>
                        </div>
                    </template>
                </template>
                <item
                        v-else
                        :key="index"
                        :item="item"
                        :first-item="true"
                        :is-collapsed="isCollapsed"
                />
            </template>
        </div>
        <div
                v-if="isCollapsed"
                :style="[{'position' : 'absolute'}, {'top' : `${mobileItemPos}px`}, rtl ? {'right' : '0px'} : {'left' : '0px'}, {'z-index' : 30}, {'width' : width}]"
        >
            <mobile-item :item="mobileItem"/>
            <transition name="slide-animation">
                <div
                        v-if="mobileItem"
                        class="vsm-mobile-bg"
                        :style="[{'position' : 'absolute'}, {'left' : '0px'}, {'right' : '0px'}, {'top' : '0px'}, {'height' : `${mobileItemHeight}px`}]"
                />
            </transition>
            <div
                    class="vsm-dropdown"
                    :style="[{'position' : 'absolute'}, {'top' : `${mobileItemHeight}px`}, {'left' : rtl ? '0px': sidebarWidth}, {'right' : rtl ? sidebarWidth: '0px'}, {'max-height' : `calc(100vh - ${mobileItemPos + mobileItemHeight}px)`}, {'overflow-y' : 'auto'}]"
            >
                <transition
                        name="expand"
                        @enter="expandEnter"
                        @afterEnter="expandAfterEnter"
                        @beforeLeave="expandBeforeLeave"
                >
                    <div
                            v-if="mobileItem && mobileItem.child"
                            class="vsm-list"
                    >
                        <sub-item
                                v-for="(subItem, index) in mobileItem.child"
                                :key="index"
                                :item="subItem"
                        />
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>
<style>
    .v-sidebar-menu, .v-sidebar-menu * {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: #f5f5f5;

    }

    .v-sidebar-menu {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        padding-bottom: 50px;
        z-index: 999;
        -webkit-transition: 0.3s width;
        transition: 0.3s width
    }

    .v-sidebar-menu.rtl {
        right: 0;
        left: inherit;
        text-align: right
    }

    .v-sidebar-menu > .vsm-list {
        width: 100%;
        height: 100%;
        overflow: hidden auto
    }

    .v-sidebar-menu.vsm-collapsed > .vsm-list {
        width: calc(100% + 17px);
        padding-right: 17px
    }

    .v-sidebar-menu.rtl > .vsm-list {
        direction: rtl
    }

    .v-sidebar-menu.vsm-collapsed.rtl > .vsm-list {
        float: right
    }

    .v-sidebar-menu .vsm-item {
        position: relative;
        display: block;
    }

    .v-sidebar-menu .vsm-item.first-item > .vsm-link > .vsm-icon {
        height: 30px;
        line-height: 30px;
        width: 30px;
        text-align: center;
        border-radius: 3px
    }

    .v-sidebar-menu .vsm-item.first-item > .vsm-link:after {
        content: '';
        display: block;
        clear: both
    }

    .v-sidebar-menu .vsm-item.mobile-item > .vsm-link > .vsm-icon {
        height: 30px;
        line-height: 30px;
        width: 30px;
        text-align: center;
        border-radius: 3px
    }

    .v-sidebar-menu .vsm-item.active-item > .vsm-link, .v-sidebar-menu .vsm-item.parent-active-item > .vsm-link {
        font-weight: 600;

    }

    .v-sidebar-menu .vsm-item.active-item > .vsm-link, .v-sidebar-menu > .vsm-link {
        font-weight: 600;
    }

    .v-sidebar-menu .vsm-link {
        position: relative;
        display: block;
        font-size: 16px;
        font-weight: 400;
        padding-top: 5px;
        padding-bottom: 5px;
        line-height: 30px;
        text-decoration: none;
        z-index: 20;
        -webkit-transition: 0.3s all;
        transition: 0.3s all
    }

    .v-sidebar-menu .vsm-link[disabled] {
        opacity: 0.4;
        pointer-events: none
    }

    #app > div.application--wrap > div > aside > div.v-sidebar-menu.vsm-default > div > div.vsm-item.first-item.open-item.active-item
    > div > div > div {
        margin-left: 5px;
    }

    .v-sidebar-menu .vsm-title {
        display: block;
        white-space: nowrap;
        padding-left: 40px;

    }

    .v-sidebar-menu .vsm-icon {
        float: left;
        line-height: 30px;
        margin-right: 10px
    }

    .v-sidebar-menu.rtl .vsm-icon {
        float: right;
        margin-right: 0px
    }

    .v-sidebar-menu .vsm-arrow {
        width: 30px;
        text-align: center;
        font-style: normal;
        font-weight: 900;
        position: absolute;
        right: 10px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        -webkit-transition: 0.3s -webkit-transform;
        transition: 0.3s -webkit-transform;
        transition: 0.3s transform;
        transition: 0.3s transform, 0.3s -webkit-transform
    }

    .v-sidebar-menu .vsm-arrow:after {
        content: '\f105';
        font-family: 'Font Awesome 5 Free'
    }

    .v-sidebar-menu .vsm-arrow.open-arrow {
        -webkit-transform: translateY(-50%) rotate(90deg);
        transform: translateY(-50%) rotate(90deg);
        color:#7a8087;
    }

    .v-sidebar-menu.rtl .vsm-arrow {
        left: 10px;
        right: inherit
    }

    .v-sidebar-menu .vsm-dropdown > .vsm-list {
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .v-sidebar-menu .expand-enter-active, .v-sidebar-menu .expand-leave-active {
        -webkit-transition: height 0.35s ease;
        transition: height 0.35s ease;
        overflow: hidden
    }

    .v-sidebar-menu .expand-enter, .v-sidebar-menu .expand-leave-to {
        height: 0 !important
    }

    .v-sidebar-menu .slide-animation-enter-active {
        -webkit-animation: slide-animation 0.2s;
        animation: slide-animation 0.2s;
    }

    .v-sidebar-menu .slide-animation-leave-active {
        animation: slide-animation 0.2s reverse
    }

    @-webkit-keyframes slide-animation {
        0% {
            width: 0%
        }
        100% {
            width: 100%
        }
    }

    @keyframes slide-animation {
        0% {
            width: 0%
        }
        100% {
            width: 100%
        }
    }

    .v-sidebar-menu .vsm-header {
        font-size: 12px;
        font-weight: normal;
        white-space: nowrap;
        padding: 10px;
    }

    .v-sidebar-menu .vsm-badge {
        font-size: 12px;
        border-radius: 3px;
        position: absolute;
        right: 10px;
        height: 20px;
        line-height: 20px;
        margin-top: 5px;
        font-weight: 600;
        text-transform: uppercase
    }

    .v-sidebar-menu.rtl .vsm-badge {
        left: 10px;
        right: inherit
    }

    .v-sidebar-menu .collapse-btn {
        display: block;
        text-align: center;
        font-style: normal;
        font-weight: 900;
        position: absolute;
        height: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        cursor: pointer;
        border: none;
        width: 100%
    }

    .v-sidebar-menu .collapse-btn:after {
        content: '\f337';
        font-family: 'Font Awesome 5 Free'
    }

    .v-sidebar-menu {
       background-color: #f5f5f5
    }

    .v-sidebar-menu .vsm-link {
        color: #6e6e6e
    }

    .v-sidebar-menu .vsm-item.mobile-item > .vsm-link {
        color: #fff
    }

    .v-sidebar-menu .vsm-item.mobile-item > .vsm-icon {
        color: #fff;
    }

    .v-sidebar-menu .vsm-item.first-item.active-item > .vsm-link, .v-sidebar-menu .vsm-item.first-item.parent-active-item > .vsm-link {

    }

    .v-sidebar-menu .vsm-item.first-item.active-item > .vsm-link > .vsm-icon, .v-sidebar-menu .vsm-item.first-item.parent-active-item > .vsm-link > .vsm-icon {

    }

    .v-sidebar-menu.rtl .vsm-item.first-item.active-item > .vsm-link, .v-sidebar-menu.rtl .vsm-item.first-item.parent-active-item > .vsm-link {

    }

    .v-sidebar-menu.vsm-default .vsm-item.first-item.open-item > .vsm-link {
        color: #6e6e6e;
    }

    .v-sidebar-menu.vsm-default .vsm-item.first-item.open-item > .vsm-link > .vsm-icon {
        color: #606266;
    }

    .v-sidebar-menu.vsm-default {
        color: #6e6e6e;
    }

    .v-sidebar-menu.vsm-default > div > div > a:hover {
        color: #606266;
    }

    .v-sidebar-menu .vsm-dropdown > .vsm-list {

    }

    .v-sidebar-menu .vsm-dropdown > .vsm-list .vsm-link {
        color: #606266
    }

    .v-sidebar-menu .vsm-dropdown > .vsm-list .vsm-link:hover {
        color: #606266;
    }

    .v-sidebar-menu .vsm-mobile-bg {
        background-color: #fad40b
    }

    .v-sidebar-menu .vsm-header {
        color: rgba(255, 255, 255, 0.7)
    }

    .v-sidebar-menu .vsm-badge.default-badge {
        color: #606266;
    }
    .v-sidebar-menu.white-theme {
        background-color: #f5f5f5
    }

    .v-sidebar-menu.white-theme .vsm-item.mobile-item > .vsm-link {
        color: #606266
    }

    .v-sidebar-menu.white-theme .vsm-item.mobile-item > .vsm-icon {
        color: #606266;
        background-color: transparent;
    }

    .v-sidebar-menu.white-theme .vsm-item.first-item.active-item > .vsm-link > .vsm-icon, .v-sidebar-menu.white-theme .vsm-item.first-item.parent-active-item > .vsm-link > .vsm-icon {
        color: #606266;
    }

    .v-sidebar-menu.white-theme.vsm-default .vsm-item.first-item.open-item > .vsm-link > .vsm-icon {
        color: #606266;
        background-color: rgba(0, 0, 0, 0)
    }

    .v-sidebar-menu.white-theme .vsm-dropdown > .vsm-list {


    }

    .v-sidebar-menu.white-theme .vsm-header {

    }

    .vsm-link > router-link-active {
        padding-left: 0px;
    }

    .v-sidebar-menu.vsm-default >
    div > div.vsm-item.first-item.open-item.parent-active-item > div > div > div > a > i {
        padding-left: 5px;
        color: #606266;
        background-color: #888c93;

    }

    .vsm-item > a {
        border-bottom: 1px solid rgba(58, 67, 82, 0.51);
    }

    .v-sidebar-menu.vsm-default > div >
    div.vsm-item.first-item.open-item.active-item > a {
        color: #606266;
    }

    .vsm-title{

        padding-left: 5px;
    }

    .v-sidebar-menu.vsm-default > div > div.vsm-item.first-item.open-item.parent-active-item > div > div > div > a > span{
        font-weight: 600;
    }

    .v-sidebar-menu.vsm-default > div > div.vsm-item.first-item.open-item.active-item > a {
        color: #606266;
    }

    .v-sidebar-menu .vsm-title {
        display: block;
        white-space: nowrap;
        color: #606266;
    }

</style>
<script>
    import Item from './Item.vue'
    import SubItem from './SubItem.vue'
    import MobileItem from './MobileItem.vue'
    import {animationMixin} from './mixin'
    import store from '../../store'
    export default {
        name: 'w-sidebar-menu',
        components: {
            Item,
            SubItem,
            MobileItem
        },
        mixins: [animationMixin],
        props: {
            menu: {
                type: Array,
                required: true
            },
            collapsed: {
                type: Boolean,
                default: false
            },
            width: {
                type: String,
                default: '350px'
            },
            widthCollapsed: {
                type: String,
                default: '50px'
            },
            showChild: {
                type: Boolean,
                default: false
            },
            theme: {
                type: String,
                default: ''
            },
            showOneChild: {
                type: Boolean,
                default: false
            },
            rtl: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                store,
                isCollapsed: this.collapsed,
                mobileItem: null,
                mobileItemPos: 0,
                mobileItemHeight: 0,
                closeTimeout: null,
                activeShow: null
            }
        },
        computed: {
            sidebarWidth() {
                return this.isCollapsed ? this.widthCollapsed : this.width
            }
        },
        watch: {
            collapsed(val) {
                this.isCollapsed = val
            }
        },
        created() {
            this.$on('mouseEnterItem', (val) => {
                this.mobileItem = null
                this.$nextTick(() => {
                    this.mobileItem = val.item
                    this.mobileItemPos = val.pos
                    this.mobileItemHeight = val.height
                })
            })

            this.$on('touchClickItem', (clearCloseTimeout) => {
                if (clearCloseTimeout) {
                    clearTimeout(this.closeTimeout)
                    return
                }
                if (this.closeTimeout) clearTimeout(this.closeTimeout)
                this.closeTimeout = setTimeout(() => {
                    this.mouseLeave()
                }, 600)
            })
        },
        methods: {
            mouseLeave() {
                this.mobileItem = null
            },
            toggleCollapse() {
                this.isCollapsed = !this.isCollapsed
                this.$emit('collapse', this.isCollapsed)
            },
            onActiveShow(uid) {
                this.activeShow = uid
            },
            onItemClick(event, item) {
                this.$emit('itemClick', event, item)
            }
        },
        provide() {
            const activeShow = {}
            Object.defineProperty(activeShow, 'uid', {
                enumerable: true,
                get: () => this.activeShow
            })
            return {
                showChild: this.showChild,
                showOneChild: this.showOneChild,
                emitActiveShow: this.onActiveShow,
                activeShow,
                emitItemClick: this.onItemClick,
                rtl: this.rtl
            }
        }
    }
</script>

